export default "//static.tradera.net/touchweb/static/output/images/mao-feature-modal-active-2x.71f364a2.png";